import { type ComponentProps } from 'react'
import { defaultUrlTransform } from 'react-markdown'
import { useAttachmentDownload } from './useAttachmentDownload'

const PRIVATE_FILE = /^\/api\/(?:chat\/[a-z0-9][a-z0-9-]{0,39}\/attachments|internal\/insight-attachments)\/[0-9a-f]{32}$/

export function attachmentUrlTransform(url: string, key: string) {
  return key === 'href' && url.startsWith('sandbox:/') ? url : defaultUrlTransform(url)
}

export function isAttachmentLink(href: string | undefined) {
  return !!href && (PRIVATE_FILE.test(href) || href.startsWith('sandbox:/'))
}

export function AttachmentLink({ href = '', children, conversationId }: ComponentProps<'a'> & { conversationId?: string }) {
  const { download, error, busy } = useAttachmentDownload()
  if (!isAttachmentLink(href)) return <a href={href}>{children}</a>
  const legacy = href.startsWith('sandbox:/')
  const url = legacy
    ? conversationId ? `/api/chat/${encodeURIComponent(conversationId)}/generated-file?reference=${encodeURIComponent(href)}` : ''
    : href
  return <>
    <a href="#" aria-disabled={busy} onClick={(event) => { event.preventDefault(); void download(url) }}>{children}</a>
    {error && <span role="alert"> {error}</span>}
  </>
}
